import { ReactElement, ReactNode } from "react";

import { SelectAllOptionLikeReactSelectStyled } from "./filter-multiselect.styled";

interface ISelectAllOptionProps {
  children: ReactNode;
  isFocused: boolean;
  isSelected: boolean;
  onFocus: (isSelected: boolean) => void;
}

export const SelectAllOption = ({
  children,
  isFocused,
  isSelected,
  onFocus,
}: ISelectAllOptionProps): ReactElement => {
  return (
    <SelectAllOptionLikeReactSelectStyled
      $isFocused={isFocused}
      $isSelected={isSelected}
      onMouseOver={() => onFocus(true)}
      onMouseLeave={() => onFocus(false)}
    >
      {children}
    </SelectAllOptionLikeReactSelectStyled>
  );
};
